import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ConfigService} from '../services/config.service';
import {LogoutService} from '../services/logout.service';
import 'jquery';

declare var $: any;

@Component({
  selector: 'app-redirect-to-bo-online',
  templateUrl: './redirect-to-bo-online.component.html',
  styleUrls: ['./redirect-to-bo-online.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class RedirectToBoOnlineComponent implements OnInit, OnDestroy {
  constructor(
    private configService: ConfigService,
    private logoutService: LogoutService
  ) {
  }

  ngOnInit() {
    this.blurMenuAndHeader();
  }

  ngOnDestroy() {
    this.unblurMenuAndHeader();
  }

  blurMenuAndHeader() {
    $('.menubo, .headerbo').css({
      'filter': 'blur(4px)',
      'pointer-events': 'none',
      'user-select': 'none'
    });
  }

  unblurMenuAndHeader() {
    $('.menubo, .headerbo').css({
      'filter': '',
      'pointer-events': '',
      'user-select': ''
    });
  }

  redirectToBoOnline() {
    window.location.href = this.configService.externalBilletterieUrl;
  }

  logout() {
    this.logoutService.logout();
  }
}
